module.exports = __webpack_public_path__ + "img/41_38.d36a2970.png";